var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "submit-tender clearfix",
      staticStyle: { display: "inline-block" },
      attrs: { "hide-overlay": true },
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn--orange",
          attrs: { slot: "activator", type: "button", id: "start-addendum" },
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
          slot: "activator",
        },
        [_vm._v(_vm._s(_vm.$t("action.addendum")))]
      ),
      _vm._v(" "),
      _c(
        "modal",
        { ref: "modal", attrs: { modalId: "start-addendum-" + +new Date() } },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { staticClass: "modal-pure-text" }, [
              _vm._v(_vm._s(_vm.$t("warn.addendum.startAddendum"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.back")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.goAddendumEdit()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.yes")))]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }